const componentData = {
  sideBar: {
    tab1: 'Appointments',
    tab2: 'Patients',
    tab3: 'Finances',
    tab4: 'Teleconsult',
    tab5: 'HAYFT',
  },
  header: {
    name: 'Have a pleasant day, DOC!',
    action: 'Show Profile',
  },
  myAvailability: {
    description: 'My Availability',
    actionText: 'Change Availability',
  },
}

const pageData = {
  appointments: {
    mainHeading: 'My Appointments',
    description:
      'Explore your scheduled appointments with your patients',
    viewSwitcherButtons: {
      gridView: 'GRID',
      calendarView: 'CALENDAR',
    },
  },
}

export default {
  componentData: { ...componentData },
  pageData: { ...pageData },
}
